"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformSimpleUsersToSelectOptions = transformSimpleUsersToSelectOptions;
function transformSimpleUsersToSelectOptions(simpleUsers) {
    return simpleUsers.map((user) => ({
        label: `${user.fullName} <${user.email}>`,
        value: user._id,
    }));
}
//# sourceMappingURL=transformSimpleUsersToSelectOptions.js.map